import { useQuery } from '@tanstack/react-query'
import { Helmet } from 'react-helmet-async'
import Technology from '../components/Technology'
import { api } from '../util'
import PageWrapper from './PageWrapper'

function Skill() {
  const { data, isLoading } = useQuery({
    queryKey: ['skills'],
    queryFn: async () => {
      const { data } = await api.get('/skills')
      return data.data
    },
  })

  return (
    <PageWrapper>
      <Helmet>
        <title>Skill Set</title>
      </Helmet>
      <h1>My Skills</h1>
      <p>
        I'm always working to get better at things, taking on challenges, and
        staying open to learning so I can do my best in both personal and work
        stuff.
      </p>
      {isLoading
        ? [...Array.from({ length: 8 })].map((_, i) => (
            <Technology
              key={i}
              isLoading={true}
            />
          ))
        : data?.map((p, index) => (
            <div key={index}>
              <Technology
                color={p.backgroundColor}
                icon={p.icon}
                name={p.name}
                type={p.type}
                useCase={p.useCase}
              />
            </div>
          ))}
    </PageWrapper>
  )
}

export default Skill
